"use client";

// packages/eden-icons/src/generated-from-source/Add.jsx
import styled from "styled-components";
import { jsx, jsxs } from "react/jsx-runtime";
var SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
var Add = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M12.75 12.75h6.5a.749.749 0 1 0 0-1.5h-6.5v-6.5a.749.749 0 1 0-1.5 0v6.5h-6.5a.749.749 0 1 0 0 1.5h6.5v6.5a.749.749 0 1 0 1.5 0v-6.5z", children: " " })
] });
var Add_default = Add;
export {
  Add_default as default
};
